export enum SystemConstants {
    SYSTEM_GAMES_SET_CURRENT_GAME = "SYSTEM_GAMES_SET_CURRENT_GAME",
    SYSTEM_GAMES_SET_ME = "SYSTEM_GAMES_SET_ME",
    SYSTEM_GAMES_SET_CLIENTS = "SYSTEM_GAMES_SET_CLIENTS",
    SYSTEM_GAMES_SET_SETTINGS_CHANGE_TIME = "SYSTEM_GAMES_SET_SETTINGS_CHANGE_TIME",
    SYSTEM_GAMES_SET_SYSTEM_PROPERTIES = "SYSTEM_GAMES_SET_SYSTEM_PROPERTIES",
    SYSTEM_GAMES_SET_SCRIPT = "SYSTEM_GAMES_SET_SCRIPT",
};
  
  